import {SET_SCOPE_ACTIVITY, SET_EMPLOYMENT, SET_EXPERIENCE, SET_COMPANY, SET_CITY} from '../constants/Filter'

export function setFilterData(id, label, type) {
  switch (type) {
    case "scope_activity":
      return {
        type: SET_SCOPE_ACTIVITY,
        id,
        label
      }
    case "employment":
      return {
        type: SET_EMPLOYMENT,
        id,
        label
      }
    case "experience":
      return {
        type: SET_EXPERIENCE,
        id,
        label
      }
    case "company":
      return {
        type: SET_COMPANY,
        id,
        label
      }
    case "city":
      return {
        type: SET_CITY,
        id,
        label
      }
    default:
      break
  }
}


// WEBPACK FOOTER //
// ./src/actions/FiltersActions.js